import { useState, useEffect } from "react";
import { useAuth } from "../../context/auth";
import { Outlet, useLocation } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner";

export default function AdminRoute({ permission }) {
  const [ok, setOk] = useState(false);
  const [auth] = useAuth();
  const location = useLocation();

  useEffect(() => {
    const authCheck = async () => {
      const res = await axios.get("/api/v1/auth/admin-auth");
      if (res.data.ok) {
        // If a specific permission is required
        if (permission) {
          const user = auth?.user;
          if (user?.role === 3) {
            setOk(true); // Super Admin has all permissions
          } else if (user?.role === 1 && user?.permissions?.includes(permission)) {
            setOk(true); // Admin has the specific permission
          } else {
            setOk(false); // Admin doesn't have the permission
          }
        } else {
          setOk(true); // General admin access
        }
      } else {
        setOk(false);
      }
    };
    if (auth?.token) authCheck();
  }, [auth?.token, permission, auth?.user]);

  return ok ? <Outlet /> : <Spinner path="" />;
}
